'use client';
import {Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList,} from "../components/ui/command"
import {Popover, PopoverContent, PopoverTrigger,} from "../components/ui/popover"
import {cn} from "../lib/utils"
import React, { CSSProperties, HTMLInputTypeAttribute, ReactNode, useEffect, useRef, useState } from 'react';
import {useTranslate} from "sbx-crm-menu-ui";
import {FormControl, FormLabel} from "@mui/material";
import {format} from "date-fns";
import {es, enUS} from "date-fns/locale";
import { ChevronDown, CalendarIcon, Check, Trash2 } from 'lucide-react';
import { StringOption } from '../types/Common';
import { containsNumbers } from './index';
import { Button } from '../components/ui/button';
import { Calendar } from '../components/ui/calendar';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Textarea } from '../components/ui/textarea';
import { Checkbox } from '../components/ui/checkbox';

type InputProps = {
    id?: string;
    label?: string |ReactNode;
    defaultValue?: string | null;
    classNameLabel?: string;
    name?: string;
    checked?: boolean;
    value?: any;
    ref?: any;
    type?: HTMLInputTypeAttribute | undefined;
    placeholder?: string;
    disabled?: boolean;
    onChange?: (value: any) => void;
    options?: { label: string ; value: any, icon?: any, type?: string[] }[];
    maxLength?: number;
    min?: number | string;
    max?: number;
    classNameContent?: string;
    required?: boolean;
    classNameInput?: string;
    isMulti?: boolean
    sortOptions?: boolean
    isLoading?: boolean
    showIcon?: boolean
    onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    style?: CSSProperties,
    styleInput?: CSSProperties
    creatable?: boolean
};

export const InputGroup = ({
                               id,
                               placeholder = '',
                               label,
                               onChange,
                               classNameLabel = '',
                               ref = null,
                               type,
                               disabled,
                               value = null,
                               maxLength,
                               min,
                               max,
                               classNameContent,
                               name,
                               checked,
                               required,
                               classNameInput,
                               onKeyDown,
                           }: InputProps) => {
    return (
        <div className={`${classNameContent ?? ''}`}>
            <label htmlFor={id} className={`block text-sm  leading-6 ${classNameLabel}`}>
                {label}
                {required && <sup className="text-[#dc3545] ml-1">*</sup>}
            </label>
            <div className="relative  rounded-md shadow-sm">
                <input
                    type={type ?? 'text'}
                    name={name}
                    id={id}
                    ref={ref}
                    min={type === "number" && min ? min : type === "number" && !min ? "-Infinity" : min}
                    max={max}
                    checked={checked}
                    maxLength={maxLength}
                    value={value || (type === "number" && typeof value === "number") ? (type === 'date' ? value.replace(/\//g, '-') : value) : ''}


                    disabled={disabled}
                    onKeyDown={(evt) => {
                        if (onKeyDown) {
                            onKeyDown(evt);
                        }
                    }}
                    // defaultValue={defaultValue || ""}
                    onChange={(evt) => {
                        if (onChange) {
                            if (type === 'checkbox') {
                                onChange(evt.target.checked);
                            } else {
                                onChange(type === 'date' ? evt.target.value.replace(/-/g, '/') : evt.target.value);
                            }
                        }
                    }}
                    className={` block w-full rounded border-[1px] focus:outline-none focus:shadow-outline p-2 
                    text-gray-900 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 ${
                        type === 'checkbox' ? '' : 'focus:ring-primary'
                    }
                    focus:ring-inset  sm:text-sm sm:leading-6 ${classNameInput ?? ''}`}
                    placeholder={placeholder}
                />
            </div>
        </div>
    );
};


export const CheckboxComponent = ({
                                      id,
                                      label,
                                      onChange,
                                      classNameLabel = '',
                                      disabled,
                                      classNameContent,
                                      name,
                                      checked,
                                      required,
                                      classNameInput = '',
                                  }: InputProps) => {

    return (
        <div className={`flex items-center gap-2 ${classNameContent}`}>
            <Checkbox
                id={id}
                name={name}
                checked={checked}
                disabled={disabled}
                className={`${classNameInput}`}
                onCheckedChange={onChange}
            />
            <Label className={`${classNameLabel}`} htmlFor="deployChat">{
                label
            } {required && <sup className="text-[#dc3545] ml-1">*</sup>}</Label>
        </div>
    );
};


export const SelectComponent = ({
                                    id,
                                    placeholder = '',
                                    label,
                                    onChange,
                                    classNameLabel = '',
                                    options = [],
                                    disabled,
                                    value = undefined,
                                    required,
                                    classNameInput = '',
                                    isMulti = false,
                                    sortOptions = true,
    showIcon = true, style,
                                    classNameContent, isLoading,
                                    creatable = true,
                                }: InputProps) => {
    const {t} = useTranslate('common')
    const {t: report} = useTranslate('report')
    const [open, setOpen] = useState(false)
    const [search, setSearch] = useState("")
    const [selectOptions, setSelectOptions] = useState<{ label: string, value: string }[]>([])
    const [topItems, setTopItems] = useState(10)
    const getValue = () => {
        if (value && (!isMulti || (isMulti && value.length > 0))) {
            if (isMulti) {
                if (!Array.isArray(value)) {
                    if (options?.length > 0) {
                        return [options?.find((option) => option.value === value[0])?.label ?? value].join(", ")
                    } else {
                        return value
                    }

                }

                if (options?.length > 0) {
                    return (value ?? []).map((v: {
                        label: string,
                        value: string
                    }) => options.find((option) => option.value === v)?.label ?? v).join(", ")

                } else {
                    return value.join(", ")
                }
            } else {

                const nValue = options.find((option) => option.value === value)?.label ?? value

                const icon = options.find((option) => option.value === value)?.icon ?? null

                return <div className="flex items-center gap-1">
                    {icon ?? null}
                    {nValue}
                </div>
            }
        }

        return placeholder?.length > 0 ? placeholder : report("select")+"..."
    }

    const handleValue = (currentValue: string) => {
        setTopItems(10)
        if (isMulti) {

            if (Array.isArray(value) && value.includes(currentValue)) {
                return value.filter((v: string) => v !== currentValue)
            } else {
                if (Array.isArray(value)) {
                    return [...(value ?? []), currentValue]
                } else {
                    return [currentValue]
                }
            }


        } else {
            return currentValue === value ? "" : currentValue
        }
    }

    useEffect(() => {
        if (options?.length > 0) {
            setSelectOptions(options)
        } else {
            if (value && Array.isArray(value)) {
                setSelectOptions(value.map((v: string) => ({label: v, value: v})))
            } else {
                setSelectOptions([]);
            }
        }


    }, [options, value]);

    const getOrderedOptions = (
        selectOptions: StringOption[],
        search: string,
        selectedOptions: string[],
        isMulti: boolean
    ): (StringOption & { icon?: any })[] => {
        // Filtrar las opciones basadas en la búsqueda
        const filteredOptions = selectOptions.filter(option =>
            search.length === 0
                ? true
                : (option.label?.toLowerCase() ?? "").includes(search.trim().toLowerCase() ?? "")
        );

        let orderedOptions = [...filteredOptions]

        // Ordenar las opciones alfabéticamente
        if (sortOptions) {
            orderedOptions = orderedOptions.sort((a, b) => {
                const labelA = a?.label ?? "";
                const labelB = b?.label ?? "";
                return labelA.localeCompare(labelB, undefined, {numeric: containsNumbers(a.label) || containsNumbers(b.label)});
            });
        }


        // Si isMulti es true, poner los seleccionados primero
        if (isMulti) {
            const selectedSet = new Set(selectedOptions);
            orderedOptions.sort((a, b) => {
                const isSelectedA = selectedSet.has(a.value);
                const isSelectedB = selectedSet.has(b.value);

                if (isSelectedA && !isSelectedB) {
                    return -1;
                } else if (!isSelectedA && isSelectedB) {
                    return 1;
                } else {
                    return 0;
                }
            });
        }


        return orderedOptions;
    }


    const showIconFn = (option: StringOption) => {
        if (isMulti) {
            if (value && Array.isArray(value) && value.length > 0) {
                return value.includes(option.value)
            }
        } else {
            return value === option.value
        }

        return false
    }

    return (
        <div className={`${classNameContent ?? ''}`}>
            {label && (
                <label htmlFor={id} className={`block text-sm  leading-6 ${classNameLabel}`}>
                    {label}
                    {required && <sup className="text-[#dc3545] ml-1">*</sup>}
                </label>
            )}
            <Popover open={open} onOpenChange={setOpen}>
                <PopoverTrigger asChild>
                    <Button
                        variant="outline"
                        disabled={disabled}
                        role="combobox"
                        aria-expanded={open}
                        style={style}
                        className={`w-full rounded border-gray-400 justify-between flex items-center ${classNameInput}`}
                    >
                        <div
                            className={`!text-ellipsis !overflow-hidden ${(!value || Array.isArray(value) && value.length === 0) ? "text-gray-300 text-sm" : ""}`}>
                            {isLoading ? t("loading") + "..." : getValue()}
                        </div>
                        <ChevronDown className="ml-2 h-4 w-4 shrink-0 opacity-50"/>
                    </Button>
                </PopoverTrigger>
                <PopoverContent className="p-0 w-auto">
                    <Command className="bg-white" disablePointerSelection={disabled} shouldFilter={false}>
                        <CommandInput disabled={disabled} value={search} onValueChange={setSearch}
                                      placeholder={`${placeholder ? ` ${placeholder}` : "Search"}...`}
                                      className={`h-9`}/>
                        <CommandList onScroll={event => {
                            const target = event.target as HTMLDivElement

                            if (target.scrollHeight - target.scrollTop === target.clientHeight) {
                                setTopItems(prevState => prevState + 10)
                            }

                            if (target.scrollTop === 0) {
                                setTopItems(10)
                            }

                        }}>
                            {!search && isMulti && value && Array.isArray(value) && value.length > 0 ? <div
                                className="p-2 flex items-center justify-between hover:bg-gray-200 cursor-pointer"
                                onClick={() => {
                                    if (onChange) {
                                        onChange([])
                                    }
                                    setSearch("")
                                    setOpen(false)
                                }}
                            >
                                <span>
                                {t("remove")} {t("all")}
                                    </span>
                                <Trash2 className={cn(
                                    "ml-auto h-4 w-4 cursor-pointer text-red-500"
                                )}/>
                            </div> : null}
                            {search.length > 0 && creatable &&
                                <CommandEmpty className={"hover:bg-gray-200 hover:cursor-pointer p-3 text-center"}
                                              onClick={() => {
                                                  if (onChange) {
                                                      onChange(handleValue(search))
                                                  }
                                                  setSearch("")
                                                  setOpen(false)
                                              }}
                                >No found. Create "{search}"</CommandEmpty>}


                            <CommandGroup className="">

                                {selectOptions ? getOrderedOptions([...selectOptions], search, Array.isArray(value) ? value : [], isMulti)
                                    .slice(0, topItems).map((option, index) => (
                                        <CommandItem
                                            className="flex items-center gap-1"
                                            key={`${option.value}_${index}`}
                                            value={`${option.value}_${index}`}
                                            onSelect={() => {
                                                if (onChange) {
                                                    onChange(handleValue(option.value))
                                                }
                                                setSearch("")
                                                setOpen(false)
                                            }}
                                        >
                                            {option.icon ?? null}
                                            {option.label}
                                            {showIcon ? (isMulti ? <Trash2 className={cn(
                                                "ml-auto h-4 w-4 cursor-pointer text-red-500",
                                                showIconFn(option) ? "opacity-100" : "opacity-0"
                                            )}/> : <Check
                                                className={cn(
                                                    "ml-auto h-4 w-4",
                                                    showIconFn(option) ? "opacity-100" : "opacity-0"
                                                )}
                                            />) : null}
                                        </CommandItem>
                                    )) : []}
                            </CommandGroup>
                        </CommandList>
                    </Command>
                </PopoverContent>
            </Popover>
        </div>
    )

    // return (
    //     <div className={`${classNameContent ?? ''}`}>
    //         {label && (
    //             <label htmlFor={id} className={`block text-sm  leading-6 ${classNameLabel}`}>
    //                 {label}
    //                 {required && <sup className="text-[#dc3545] ml-1">*</sup>}
    //             </label>
    //         )}
    //         <div className="relative  rounded-md shadow-sm">
    //             <select
    //                 name={id}
    //                 className={`text-gray-500 rounded p-2 border bg-white w-full ${classNameInput ?? ''}`}
    //                 id={id}
    //                 value={value ?? ''}
    //                 disabled={disabled}
    //                 onChange={(evt) => {
    //                     if (onChange) {
    //                         onChange(evt.currentTarget.value);
    //                     }
    //                 }}
    //
    //                 // placeholder={placeholder}
    //             >
    //                 <option disabled key={'default_first'} value={''}>
    //                     {placeholder?.length > 0 ? placeholder : 'Select an option'}
    //                 </option>
    //                 {options?.map((option) => (
    //                     <option key={option.value} value={option.value}>
    //                         {option.label}
    //                     </option>
    //                 ))}
    //             </select>
    //         </div>
    //     </div>
    // );
};

export const RadioButtonComponent = ({
                                         name,
                                         onChange,
                                         checked,
                                         label,
                                         value,
                                         disabled,
                                         classNameLabel,
                                         id,
                                         styleInput = {}
                                     }: InputProps) => {
    return (
        <label key={name} className={`${classNameLabel ?? 'items-center'} flex  cursor-pointer`} htmlFor={id}>
            <input
                id={id}
                style={styleInput}
                type="radio"
                disabled={disabled}
                value={value}
                onChange={(evt) => {
                    if (onChange) {
                        onChange(evt.currentTarget.value);
                    }
                }}
                checked={checked}
                className={`cursor-pointer`}
            />
            <span className="ml-1 cursor-pointer w-max">{label}</span>
        </label>
    );
};

export const RadioButtonGroupComponent = ({options, classNameContent, onChange}: {
    options: {
        name: string, value: boolean, label?: string
    }[]
} & InputProps) => {

    const [checked, setChecked] = useState("")

    return <div className={`flex gap-2 items-center ${classNameContent}`}>
        {options.map((option, index) => {
            return <RadioButtonComponent key={`${option.name}_${index}`}
                                         value={option.value}
                                         checked={option.name === checked}
                                         onChange={value => {
                                             setChecked(option.name)
                                             if (onChange) {
                                                 onChange(value)
                                             }
                                         }}
                                         label={option.label ?? ""}/>
        })}
    </div>
}




export const CalendarInputComponent = ({value, onChange, label}: InputProps) => {

    const [open, setOpen] = useState(false)

    return <div className="flex flex-col">
        {label && <FormLabel>{
            label
        }</FormLabel>}
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <FormControl>
                    <Button
                        variant={"outline"}
                        className={cn(
                            "w-full pl-3 text-left font-normal",
                            !value && "text-muted-foreground"
                        )}
                    >
                        {value ? (
                            format(value, "PPP")
                        ) : (
                            <span>Pick a date</span>
                        )}
                        <CalendarIcon className="ml-auto h-4 w-4 opacity-50"/>
                    </Button>
                </FormControl>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0" align="start">
                <Calendar
                    locale={(localStorage.getItem('crm_local') ?? 'es') === 'es' ? es : enUS}
                    mode="single"

                    selected={value}
                    onSelect={date => {
                        onChange?.(date)
                        setOpen(false)
                    }}
                    // disabled={(date) =>
                        // date > new Date() || date < new Date("1900-01-01")
                    // }
                    initialFocus
                />
            </PopoverContent>
        </Popover>
    </div>
}

export const ColorPickerComponent = ({ label, value, onChange, placeholder = "", classNameContent = "", classNameLabel = "", classNameInput = "", disabled}: InputProps) => (

    <div className={`flex flex-col space-y-1.5 ${classNameContent}`}>
        <label className={`${classNameLabel}`}>{label}</label>
        <div className="flex items-center space-x-2">
            <Input
                type="color"
                value={value || ''}
                placeholder={placeholder}
                disabled={disabled}
                onChange={e => onChange?.(e.target.value)}
                className="w-14 h-14  p-1 rounded-xl border cursor-pointer"
            />
            <Input
                type="text"
                value={value || ''}
                placeholder={placeholder}
                disabled={disabled}
                onChange={e => onChange?.(e.target.value)}
                className={`flex-grow bg-white border-gray-300 text-gray-900 rounded ${classNameInput}`}
            />
        </div>
    </div>
);

export const TextAreaComponent = ({label, name, value, placeholder, onChange, classNameInput = "", classNameContent = "", classNameLabel = "", disabled}: InputProps) => {

    const textareaRef = useRef<HTMLTextAreaElement>(null)

    useEffect(() => {
        const textarea = textareaRef.current
        if (textarea) {
            textarea.style.height = 'auto'
            const scrollHeight = textarea.scrollHeight
            textarea.style.height = `${Math.min(scrollHeight, 200)}px`
        }
    }, [value])

   return <div className={`${classNameContent}`}>
       {label && <Label htmlFor={label as string} className={`${classNameLabel || "text-sm font-medium text-gray-700"}`}>
           {label}</Label>}
        <Textarea
            ref={textareaRef}
            id={(label || name || "") as string }
            value={value}
            disabled={disabled}
            onChange={(e) => onChange?.(e.target.value)}
            placeholder={placeholder}
            className={`mt-1 bg-white border-gray-300 text-gray-900 ${classNameInput}`}
        />
    </div>
}